import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api/menuitem';
import { Profiles } from 'src/app/utils/enums/profiles';
import { CustomMenuBarService } from '../../services/custom-menu-bar.service';
import { IUser } from '../../interfaces/user.interface';

@Component({
  selector: 'custom-menu-bar',
  templateUrl: './custom-menu-bar.component.html',
  styleUrls: ['./custom-menu-bar.component.css']
})
export class CustomMenuBarComponent implements OnInit {
  constructor(
    private readonly _router: Router,
    private readonly _menuBarService : CustomMenuBarService
  ){}
  menu: MenuItem[] = [];
  menuUser: MenuItem[] = [];
  profile?: string;
  user: IUser = {
    name: '', lastName: ''
  };

  ngOnInit(): void {
    this.profile = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!).profile : Profiles.ADMIN
    this.user.name = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!).name : ''
    this.user.lastName = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!).lastName : ''

    if(this.profile ===  Profiles.ANALIST){
      this.menu = this._menuBarService.analystMenuBar()
    }
    if(this.profile ===  Profiles.PROVIDER){
      this.menu = this._menuBarService.providerMenuBar()
    }
    if(this.profile ===  Profiles.ADMIN){
      this.menu = this._menuBarService.adminMenuBar()
    }
    this.menuUser = [
      {
          items: [
            {
                label: this.user.name + ' ' + this.user.lastName ,
                icon: 'pi pi-user',
                styleClass: 'non-clickable-item'
            },
            {
              label: 'Cerrar Sesión',
              icon: 'pi pi-sign-out',
              command: ()=> this.logout()
            }
          ]
      }
    ];

  }

  logout(){
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    this._router.navigate(['/'])
  }
}
